export const escritas = {
  titulo: 'Gravação no cadastro (Axiis)',
  camiseta: 'Camiseta',
  endereco: 'Endereço oficial',
  incompleto: 'Gravado sem cidade ou estado',
  status: {
    pendente: 'Pendentes: {{n}}',
    sucesso: 'Gravadas: {{n}}',
    falha: 'Com falha: {{n}}',
  },
  retentar: 'Tentar gravar de novo',
  confirmarRetentar:
    'Tentar de novo a gravação no Axiis dos itens pendentes e com falha? Os valores são os da última resposta de cada pessoa.',
  resultado_zero: '{{count}} gravados, {{falha}} com falha.',
  resultado_one: '{{count}} gravado, {{falha}} com falha.',
  resultado_other: '{{count}} gravados, {{falha}} com falha.',
} as const;
